import React from 'react';

const CoreValues: React.FC = () => {
  const values = [
    {
      icon: "/images/icons/lightbulb-on.png",
      title: "Creativity",
      description: "We believe creativity is the heart of every impactful brand.",
      bgColor: "bg-brand-orange"
    },
    {
      icon: "/images/icons/data-report.png",
      title: "Strategy",
      description: "We root every idea in strategic thinking to ensure it moves people and markets.",
      bgColor: "bg-brand-blue"
    },
    {
      icon: "/images/icons/shield-check.png",
      title: "Integrity",
      description: "We are honest, transparent, and committed to your vision.",
      bgColor: "bg-brand-orange"
    },
    {
      icon: "/images/icons/rocket-lunch.png",
      title: "Innovation",
      description: "We embrace fresh ideas, modern technologies, and bold approaches.",
      bgColor: "bg-brand-blue"
    },
    {
      icon: "/images/icons/talent-hand.png",
      title: "Excellence",
      description: "We strive for perfection in every project, every time.",
      bgColor: "bg-brand-orange"
    }
  ];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The principles that guide everything we do
          </p>
        </div>
        
        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {values.map((value, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow duration-300"
            >
              {/* Icon */}
              <div className={`w-12 h-12 ${value.bgColor} rounded-lg flex items-center justify-center mx-auto mb-4`}>
                <img 
                  src={value.icon} 
                  alt={value.title}
                  className="w-6 h-6 object-contain filter brightness-0 invert"
                />
              </div>

              {/* Content */}
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {value.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
